import React from 'react';
import PageControl from './components';

function App() {
  return (
    <PageControl />
  );
}

export default App;
